import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface ApplicationConfigurationValidatorProps {
  errorMessage: string;
}

export default function InvalidApplicationConfigurationView({
  errorMessage,
}: ApplicationConfigurationValidatorProps) {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: 5,
      }}
    >
      <Typography variant="h4" color="error" gutterBottom>
        There is a problem with the application configuration:
      </Typography>
      <Typography variant="h5" color="error" sx={{ whiteSpace: 'pre-wrap' }}>
        Message: <br />
        {errorMessage}
      </Typography>
      <Typography variant="h6" color="error" sx={{ mt: 3 }}>
        Check index.html to resolve the issue.
      </Typography>
    </Box>
  );
}
